import PropTypes from "prop-types";

const PropIconData = PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string
});

export default PropIconData;
